function LoginloadView(view) {
  return () =>
    import(
      /* webpackChunkName: "view-[request]" */ `@/html/subpage/util/login/${view}.vue`
    );
}

const utilRoutes = [
  /* Util */

  // 로그인
  {
    path: '/loginmain',
    name: 'loginmain',
    component: LoginloadView('LoginMain'),
    meta: {
      onlyGuest: true,
    },
  },
];

export default utilRoutes;
